module.exports = __webpack_public_path__ + "img/register_form.f2fe282b.png";